
import Vue from "vue";
import { IContainer } from "@/shared/models/container.model";
import { INode } from "@/shared/models/node.model";
import GuidelineItem from '../components/GuidelineItem.vue'
import GuidelineHeading from './GuidelineHeading.vue'
import { HtmlHelper } from "@/shared/lib/htmlhelper";

export default Vue.extend({
    name: "GuidelineBox",

    components: {
        GuidelineItem,
        GuidelineHeading
    },
    props: {
        item: Object as () => IContainer,
        chapter: Object as () => INode,
        treeNode: Object as () => INode
    },
    data() {
        return {
            informationDialog: false,
            firstLevel: 2 as number
        };
    },

    methods: {
        replaceDomainInText(text: string): string {
            const helper = new HtmlHelper();
            return helper.replaceUrlToCurrentDomain(text);
        },
        getStartPage(): string {
            const helper = new HtmlHelper();
            return helper.getBaseUrl();
        },
        getChapterPage(): string {
            return this.getStartPage() + this.chapter.Url;
        },
        isAdmin(): boolean {
            return this.$store.state.isTdAdmin;
        },
        isInCart(): boolean {
            return this.$store.state.cart?.some((cartItem: any) => cartItem.Id === this.item?.Id);
        },
        getPath(): string {
            if (this.item.IsInventoryObject && this.treeNode?.BreadCrumb) {
                // For io-containers, use parent breadcrumb only (not the io-container name)
                return this.treeNode.BreadCrumb.join(' / ');
            } else if (this.item.BreadCrumb) {
                return this.item.BreadCrumb.join(' / ');
            }
            return this.item.Name;
        },
        addToCart(): void {
            const result = this.$store.state.cart;
            
            // Get URL from treeNode if available
            const itemUrl = this.treeNode?.Url || this.chapter?.Url || '';
            
            // Create cart item with Id, Path, and Data
            const cartItem = {
                Id: this.item.Id,
                Path: this.getPath(),
                Url: itemUrl,
                Data: this.cloneItemData(this.item)
            };
            
            result.push(cartItem);
            this.$store.commit("SET_CART", result);
        },
        cloneItemData(item: any): any {
            // Deep clone the item data to store in cart
            return {
                Id: item.Id,
                Name: item.Name,
                Description: item.Description,
                Information: item.Information,
                Text: item.Text,
                Level: item.Level,
                IsInventoryObject: item.IsInventoryObject,
                GuidelineItems: item.GuidelineItems ? item.GuidelineItems.map((gi: any) => ({
                    Id: gi.Id,
                    Name: gi.Name,
                    Text: gi.Text,
                    Description: gi.Description,
                    Responsibility: gi.Responsibility,
                    Extended: gi.Extended ? {
                        Condition: gi.Extended.Condition,
                        Reference: gi.Extended.Reference,
                        ReferenceUrl: gi.Extended.ReferenceUrl
                    } : null,
                    Normal: gi.Normal ? {
                        Condition: gi.Normal.Condition,
                        Reference: gi.Normal.Reference,
                        ReferenceUrl: gi.Normal.ReferenceUrl
                    } : null
                })) : [],
                Children: item.Children ? item.Children.map((child: any) => this.cloneItemData(child)) : []
            };
        },
        removeFromCart(): void {
            const result = this.$store.state.cart?.filter((cartItem: any) => cartItem.Id !== this.item.Id);
            this.$store.commit("SET_CART", result);
        },
    },
});
